define(['underscore'],
    (_) => {

        function Driver(data) {

            if (data) {
                _.extend(this, data);
            }
        }

        Driver.prototype.getDisplayName = function (defaultName, $filter) {
            return this.person.getDisplayName(defaultName, $filter);
        };

        Driver.prototype.getDriverStatesForCountry = function (states, countryCode) {
            return _.filter(states, (state) => {
                const countryConstraint = _.find(state.categories, (constraint) => {
                    return _.keys(constraint).indexOf('Country') !== -1;
                });
                if (countryConstraint) {
                    return countryConstraint.Country === countryCode;
                } 
                    return false;
                

            });
        };


        return Driver;
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/models/Driver.js